import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

export function LogoGemIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  )
}

export function ArrowRightIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      aria-hidden="true"
      {...props}
    >
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  )
}

export function BoltIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      aria-hidden="true"
      {...props}
    >
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
    </svg>
  )
}

export function PlayCircleIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M10 8l6 4-6 4V8z" fill="currentColor" stroke="none" />
    </svg>
  )
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      aria-hidden="true"
      {...props}
    >
      <path d="M6 9l6 6 6-6" />
    </svg>
  )
}

const landingIconPaths = {
  menu: 'M4 6h16 M4 12h16 M4 18h16',
  diagonal: 'M6 18L18 6 M6 6h12v12',
  down: 'M12 4v16 M5 13l7 7 7-7',
  check: 'M5 12l4 4L19 6',
  plus: 'M12 5v14 M5 12h14',
  star: 'M12 2v20 M2 12h20 M5 5l14 14 M5 19L19 5',
  sparkle: 'M12 3l2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z',
  refresh: 'M20 7v5h-5 M20 12a8 8 0 1 0-2 5 M20 12l-2-5',
  mail: 'M3 5h18v14H3Z M3 6l9 7 9-7',
  page: 'M4 4h16v16H4z M4 9h16 M7 6.5h.01 M10 6.5h.01 M8 13h8 M8 16h5',
  payment: 'M3 5h18v14H3z M3 10h18 M7 15h4',
  people:
    'M15 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M6 20v-2a6 6 0 0 1 12 0v2 M18 5a3 3 0 0 1 0 6 M21 19v-2a5 5 0 0 0-3-4 M6 5a3 3 0 0 0 0 6 M3 19v-2a5 5 0 0 1 3-4',
  wheel:
    'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M12 3v6 M12 15v6 M3 12h6 M15 12h6 M5.6 5.6l4.3 4.3 M14.1 14.1l4.3 4.3 M5.6 18.4l4.3-4.3 M14.1 9.9l4.3-4.3',
  target:
    'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0 M12 12h.01',
  dashboard: 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
} as const

export function LandingIcon({
  name,
  ...props
}: IconProps & { name: keyof typeof landingIconPaths }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d={landingIconPaths[name]} />
    </svg>
  )
}
